import Color from 'color'
import { PrivateRoute } from 'components/PrivateRoute'
import { isCorporateDataLoaded } from 'data/auth/selectors'
import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { makeStyles } from 'tss-react/mui'

import { Fade } from '@mui/material'

import { LoadingScreen } from './components-next/Loading'
import { Sidebar } from './components/Sidebar'
import { DASHBOARD_PATH, DEAL_MANAGER_PATH, ORGANIZATION_MANAGER_PATH, PEOPLE_MANAGER_PATH } from './Dashboard.routes'
import { PairingManager } from './scenes/DealManager'
import OrganizationsManager from './scenes/OrganizationsManager'
import { PeopleManager } from './scenes/PeopleManager'
import { SearchEngine } from './scenes/SearchEngine'
import { SEARCH_ENGINE_PATH } from './scenes/SearchEngine/SearchEngine.routes'
import { USER_MANAGER_PATH, UserManager } from './scenes/UsersManager'
import { CORPORATE_MANAGER_PATH, CorporateManager } from './scenes/CorporateManager'
import { SCOUTING_CAMPAIGN_MANAGER_PATH, ScoutingCampaignManager } from './scenes/ScoutingCampaignManager'
import { SUBSPACES_PATH, SubspacesManager } from './scenes/SubspaceManager'

export const Dashboard = React.memo(() => {
  const { classes } = useStyles()
  const isReady = useSelector(isCorporateDataLoaded)

  if (!isReady) {
    return <LoadingScreen />
  }

  return (
    <Fade in>
      <div className={classes.root}>
        <Sidebar />
        <main className={classes.content}>
          <Switch>
            <PrivateRoute path={SUBSPACES_PATH} component={SubspacesManager} />
            <PrivateRoute path={USER_MANAGER_PATH} component={UserManager} />
            <PrivateRoute path={DEAL_MANAGER_PATH} component={PairingManager} />
            <PrivateRoute path={ORGANIZATION_MANAGER_PATH} component={OrganizationsManager} />
            <PrivateRoute path={SCOUTING_CAMPAIGN_MANAGER_PATH} component={ScoutingCampaignManager} />
            <PrivateRoute path={CORPORATE_MANAGER_PATH} component={CorporateManager} />
            <PrivateRoute path={PEOPLE_MANAGER_PATH} component={PeopleManager} />
            <PrivateRoute path={SEARCH_ENGINE_PATH} component={SearchEngine} />
            <Route exact path={DASHBOARD_PATH}>
              <Redirect to={DEAL_MANAGER_PATH} />
            </Route>
            <Route exact path="/">
              <Redirect to={DASHBOARD_PATH} />
            </Route>
          </Switch>
        </main>
      </div>
    </Fade>
  )
})

Dashboard.displayName = 'Dashboard'

const useStyles = makeStyles()(({ spacing, breakpoints }) => ({
  root: {
    display: 'flex',
    position: 'relative',
    zIndex: 1,
    width: '100%',
    [breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  loading: {
    width: 60,
    height: 60,
  },
  loadingScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: Color('#FFF').alpha(0.7).string(),
    zIndex: 99,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    position: 'relative',
    flexGrow: 1,
    padding: spacing(3),
    minHeight: '100vh',
    [breakpoints.down('sm')]: {
      padding: spacing(2),
    },
  },
}))
